import { ProcessedData } from "../../../store/types";
import { sortSecurities } from "../../../store/utils";

export interface UserData {
  token: string;
  data: ProcessedData;
}

export const validateToken = async (dataFetching: Promise<any>): Promise<UserData | null> => {
  let userData: UserData | null = null;

  await dataFetching.then((res) => {
    if (res.meta.requestStatus !== "fulfilled") return;

    const { data, token } = res.payload as UserData;
    const { securities, principal, quote_feeds } = data;

    const sortedSecurities = sortSecurities(securities);

    const updatedData = {
      securities: sortedSecurities,
      principal,
      quote_feeds,
    };

    userData = { token, data: updatedData };
  });

  return userData;
};
